import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IFilterItem } from "../../models/filter-item-model";
import IFilterGroup from "../../models/filter-group-model";
import { BaseFilterService } from "../base-filter-service";

export class VUFilterService extends BaseFilterService {
    private explicitSearchFilters: string[] = [];
    private implicitSearchFilters: string[] = [];

    public initialize(): IFilterGroup[] {
        this.determineImplicity();
        this.checkUserFilters();

        return this.userFilters;
    }

    public shouldDisable(filterGroup: IFilterGroup, filterItem: IFilterItem): boolean {
        this.determineImplicity();

        let useImplicit: boolean = filterGroup.UseImplicitFilters ?? false;
        let inExplcit: boolean = this.explicitSearchFilters.includes(filterItem.FilterCodeName);
        let inImplicit: boolean = this.implicitSearchFilters.includes(filterItem.FilterCodeName);

        return useImplicit ? !(inExplcit || inImplicit) : !inExplcit;
    }

    private determineImplicity(): void {
        this.explicitSearchFilters = this.searchFilters.Filter.map((filter: IDictionary<any>) => filter.value);
        this.implicitSearchFilters = this.searchFilters.ImplicitFilter.map((filter: IDictionary<any>) => filter.value);
    }

    private checkUserFilters() {
        this.userFilters.map((filterGroup: IFilterGroup) => {
            filterGroup.FilterItems.map((x: IFilterItem) => {
                x.IsExplicit = this.explicitSearchFilters.includes(x.FilterCodeName);
                x.IsImplicit = this.implicitSearchFilters.includes(x.FilterCodeName);
            });

            filterGroup.FilterItems = this.removeUnusedFilters(filterGroup);
        });

        this.userFilters = this.removeFilterGroupsWithSingleFilter(this.userFilters);
    }

    /**
     * Removes filter groups that contain only a single filter item. As these
     * groups are not useful for filtering.
     */
    private removeFilterGroupsWithSingleFilter(filterGroups: IFilterGroup[]): IFilterGroup[] {
        return filterGroups.filter((filterGroup: IFilterGroup) => {
            return filterGroup.FilterItems.length > 1;
        });
    }

    private removeUnusedFilters(filterGroup: IFilterGroup) {
        return filterGroup.FilterItems.filter((filterItem: IFilterItem) => {
            return filterItem && filterGroup.UseImplicitFilters ?
                filterItem.IsExplicit || filterItem.IsImplicit :
                filterItem.IsExplicit;
        });
    }
}
